import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { gapi } from "gapi-script";
import { LinearProgress, styled, Switch, withStyles } from "@material-ui/core";
import googleDriveEnvVar from "../../constants/GoogleDriveEnvironmentVariables";
import "./storage-indicator.css";

const CustomSwitch = withStyles((theme) => ({
    root: {
        padding: 5,
        width: 62,
    },
    switchBase: {
        padding: 9,
        '&$checked': {
            transform: 'translateX(23px)',
            color: '#fff', // Button color when the switch is ON (white)
            '& + $track': {
                backgroundColor: '#0000FF', // Background color when the switch is ON (blue)
                opacity: 1,
            },
        },
    },
    track: {
        borderRadius: 28 / 2,
        backgroundColor: '#8E8B8B', // Background color when the switch is OFF
        opacity: 1,
    },
    checked: {},
}))(Switch);

export const StorageIndicator = ({ uploadToggle, uploadInDrive }) => {
    const therapist = useSelector(state => state.data.therapist);

    const [StorageIndicator, setStorageIndicator] = useState(0);
    const [therapistStorageUsed, setTherapistStorageUsed] = useState(0);

    useEffect(() => {
        // console.log("test");
        getIndicator();
    }, [therapist.storageUsedInBytes]);

    const totalStorageAllowed = 1; // in GB i.e., 1 GB
    const oneGBInBytes = 1073741824; // 1 GB

    function getIndicator() {
        const therapistStorage = therapist.storageUsedInBytes / oneGBInBytes;
        setTherapistStorageUsed(therapistStorage);
        const storageIndicateValue = (100 * therapistStorage) / totalStorageAllowed; // Percentage
        setStorageIndicator(storageIndicateValue);
    }

    const [profileImage, setProfileImage] = useState(null);

    const BorderLinearProgress = styled(LinearProgress)(() => ({
        height: 26,
        borderRadius: 13,
    }));

    const loadUserProfile = () => {
        const profile = gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile();
        if (profile) {
            const profileImageUrl = profile.getImageUrl();
            setProfileImage(profileImageUrl);
        }
    };

    const handleSignIn = async () => {
        try {
            const user = await gapi.auth2.getAuthInstance().signIn({
                scope: "profile https://www.googleapis.com/auth/drive.file"
            });
            console.log("User signed in and permissions granted", user);

            loadUserProfile();

            const hasDrivePermission = await user.hasGrantedScopes("https://www.googleapis.com/auth/drive.file");
            console.log("hasDrivePermission", hasDrivePermission);

            if (!hasDrivePermission) {
                console.error("Google Drive access not granted.");
                await handleSignOut();
                alert(`
                    Google Drive access is required to continue. 
                    You have been signed out.
                    Please sign in again with same account.
                `);
            } else {
                console.log("Google Drive permission confirmed.");
                window.location.reload();
            }
        } catch (error) {
            console.error("Error during sign-in or permission check:", error);
            alert("Access not granted. Please try again.");
        }
    };

    const handleSignOut = async () => {
        try {
            const auth2 = gapi.auth2.getAuthInstance();

            // await auth2.disconnect();
            // console.log('User permissions revoked.');
            localStorage.removeItem('isGoogleUpload');
            await auth2.signOut();
            console.log('User signed out.');

            setProfileImage(null);
            window.location.reload();
        } catch (error) {
            console.error("Error in handleSignOut:", error);
        }
    };

    const initClient = async () => {
        try {
            await gapi.client.init({
                clientId: googleDriveEnvVar.CLIENTID,
                discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
                scope: "https://www.googleapis.com/auth/userinfo.profile"
            });

            const authInstance = await gapi.auth2.getAuthInstance();
            if (await authInstance.isSignedIn.get()) {
                loadUserProfile();
            }
        } catch (error) {
            console.error('Error initializing Google API client', error);
        }
    };

    /**
     * uncomment below  code Enable Google Drive integration
    */

    // useEffect(() => {
    //     gapi.load('client:auth2', initClient);
    // }, []);

    return (
        <>
            <div className="indicator-area">
                <div style={{ flexGrow: 1 }}>
                    <div style={{ display: "flex", alignItems: "baseline", fontSize: "1rem", fontWeight: 500, gap: 5 }}>
                        <p>{therapistStorageUsed.toFixed(2)}GB lagerplads opbrugt</p>
                        <p style={{ fontSize: "0.8rem", opacity: 0.5 }}>
                            (af i alt {totalStorageAllowed}GB)
                        </p>
                    </div>
                    <BorderLinearProgress
                        color={StorageIndicator > 80 ? 'secondary' : 'primary'}
                        variant="determinate"
                        value={StorageIndicator}
                    />
                </div>
                {/**
                 * uncomment below code Enable Google Drive integration
                */}
                {/* <div style={{ display: "flex", margin: "1rem 1rem 0" }}>
                {profileImage ? (
                    <div className="drive-profile">
                        <img src={profileImage} alt="Profile" style={{ borderRadius: "50%", height: "45px", gap: '5%' }} />
                        <div className="upload-area">
                            <div className="upload-text-signout">
                                <p className="upload-area-text">Upload til Drive</p>
                                <div className="logout-button" title="Fjern Google drive integration">
                                    <img src="images/logoutIcon.svg" alt="success" style={{ cursor: "pointer" }} onClick={() => handleSignOut()} />
                                </div>
                            </div>
                            <CustomSwitch checked={uploadInDrive} className="upload-area-button" color="primary" onClick={() => uploadToggle()} />
                        </div>
                    </div>
                ) : (
                    <button
                        className="integration-button"
                        onClick={() => handleSignIn()}
                    >
                        <img src="images/googledriveIcon.svg" height={25} alt="" />
                        <p>Integrer med Google Drive</p>
                    </button>
                )
                }
            </div> */}
            </div>
            {(StorageIndicator > 80) &&
                (<p style={{ color: "red", marginLeft: "30px" }}>
                    {StorageIndicator.toPrecision(4)}% af lagerpladsen er i brug. For at fortsætte med at uploade, skal du enten opgradere din lagerplads eller slette gamle filer.
                </p>)
            }
        </>
    );
};
